import React, { useEffect, useState } from 'react';
import GoogleMapReact from 'google-map-react';

const Map = ({ setCoordinates, coordinates, distributor, setChildClicked }) => {

    const ckEditorRawTextPre = document.querySelector('#distributor-ck-editor-text-pre .field--name-field-distributor-text');
    const ckEditorRawTextPost = document.querySelector('#distributor-ck-editor-text-post .field--name-field-distributor-text-post');

    if (ckEditorRawTextPre !== null) {
        var ckEditorTextPre = ckEditorRawTextPre.innerHTML;
    } else {
        var ckEditorTextPre = '';
    }

    if (ckEditorRawTextPost !== null) {
        var ckEditorTextPost = ckEditorRawTextPost.innerHTML;
    } else {
        var ckEditorTextPost = '';
    }

    const [getCity, setGetCity] = useState();
    const [getCounty, setGetCounty] = useState();
    const [getUsState, setGetUsState] = useState();
    const [ckEditorPre, setCkEditorPre] = useState(ckEditorTextPre);
    const [ckEditorPost, setCkEditorPost] = useState(ckEditorTextPost);
    const [activeMarker, setActiveMarker] = useState(null);
    const mapDefaultCenter = { lat: 34.06533469999998, lng: -118.243891 }

    const [mapCenter, setMapCenter] = useState();

    const handleActiveMarker = (marker, mapcenterlat, mapcenterlng) => {
        if (marker === activeMarker) {
            return;
        }
        setActiveMarker(marker);
        setMapCenter({ lat: mapcenterlat, lng: mapcenterlng });
    };

    function readMore() {
        document.getElementById('distributor-places').scrollIntoView({
            behavior: 'smooth'
        });
    }

    function GetAddress() {
        var lat = coordinates.lat;
        var lng = coordinates.lng;
        var latlng = new google.maps.LatLng(lat, lng);
        var geocoder = geocoder = new google.maps.Geocoder();
        geocoder.geocode({ 'latLng': latlng }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                if (results[1]) {
                    const getResultLenght = results.length;

                    if (results.length === getResultLenght) {
                        const getCountyData = results[getResultLenght - 3].formatted_address;
                        const getUsStateData = results[getResultLenght - 2].formatted_address;
                        const getCityData = results[getResultLenght - 4].formatted_address;
                        setGetCity(getCityData.split(', ', 2));
                        setGetCounty(getCountyData.split(', ', 2));
                        setGetUsState(getUsStateData.split(', ', 2));
                    }
                    if (results.length <= 4) {
                        const getCountyData = results[3].formatted_address;
                        const getUsStateData = results[4].formatted_address;
                        const getCityData = results[2].formatted_address;
                        setGetCity(getCityData.split(', ', 2));
                        setGetCounty(getCountyData.split(', ', 2));
                        setGetUsState(getUsStateData.split(', ', 2));
                    }
                }
            }
        });
    }

    useEffect(() => {
        GetAddress();
        setMapCenter(coordinates);
    }, [coordinates]);


    $("input").focusin(function () {
        $(document).keypress(function (e) {
            if (e.which == 13) {
                var firstResult = $(".pac-container .pac-item:first").text();
                var geocoder = new google.maps.Geocoder();
                geocoder.geocode({ "address": firstResult }, function (results, status) {
                    console.log(results)
                    if (status == google.maps.GeocoderStatus.OK) {
                        var lat = results[0].geometry.location.lat();
                        var lng = results[0].geometry.location.lng();
                        //placeName = results[0].address_components[0].long_name,
                        //latlng = new google.maps.LatLng(lat, lng);
                        var latlng = { lat: lat, lng: lng }
                        console.log(latlng);

                        $(".pac-container .pac-item:first").addClass("pac-selected");
                        $(".pac-container").css("display", "none");
                        $("#searchTextField").val(firstResult);
                        $(".pac-container").css("visibility", "hidden");

                        setCoordinates(latlng);
                    }
                });
            } else {
                $(".pac-container").css("visibility", "visible");
            }
        });
    });

    return (
        <> {
            distributor.length > 0 ? <div className="bauer-distributor-map-container">
                <div className="bauer-distributor-finder-info-box-top" dangerouslySetInnerHTML={{ __html: ckEditorPost }}>
                    {/*}
                <p>For US Industrial Air Applications, please contact us at <a href="mailto:IndustrialSales@bauercomp.com">IndustrialSales@bauercomp.com</a></p>
                <p>For Canada Industrial Air Applications, please contact Jeremy Rowand at <a href="mailto:jrowand@jordair.ca">jrowand@jordair.ca</a></p>
                */}
                </div>
                <div className="bauer-google-map">
                    <GoogleMapReact
                        bootstrapURLKeys={{ key: 'AIzaSyBLCLRW6W9t8Ail1CZ5oLU_iO3n7vkyads', language: 'en-us', }}
                        defaultCenter={mapDefaultCenter}
                        center={mapCenter}
                        defaultZoom={5.4}
                        margin={[50, 50, 50, 50]}
                        options={''}
                        onChange={(e) => {
                            //setCoordinates({ lat: e.center.lat, lng: e.center.lng });
                            //console.log(e);
                        }}
                        onChildClick={(child) => setChildClicked(child)}
                    >
                        {distributor?.map((place, i) => {
                            const coverageId = place.field_distributor_coverage_id;

                            if (coverageId !== undefined) {
                                if (coverageId.includes(",")) {
                                    var coverage = coverageId.split(', ');
                                } else {
                                    coverage = [coverageId]
                                }
                            }

                            //console.log(getCity)
                            //console.log(getCounty)
                            //console.log(getUsState)

                            const foundCity = getCity.some(r => coverage.indexOf(r) >= 0);
                            const foundCounty = getCounty.some(r => coverage.indexOf(r) >= 0);
                            const foundUsState = getUsState.some(r => coverage.indexOf(r) >= 0);

                            const placeLat = Number(place.field_map_latitude);
                            const placeLng = Number(place.field_map_longitude);

                            if (foundCounty === true || foundUsState === true || foundCity === true) {
                                return (
                                    <div
                                        className={`distributor-map-marker prime-distributor-marker`}
                                        lat={Number(place.field_map_latitude)}
                                        lng={Number(place.field_map_longitude)}
                                        onClick={() => handleActiveMarker(i, placeLat, placeLng)}
                                        key={i}
                                    >
                                        {activeMarker === i ? (
                                            <div>
                                                <div className="distributor-map-marker-box">
                                                    <div className="distributor-map-marker-box-close" onClick={() => setActiveMarker(null)}>X</div>
                                                    <div className="distributor-map-marker-box-title" dangerouslySetInnerHTML={{ __html: place.field_short_name }}></div>
                                                    <div className="distributor-map-marker-box-address" dangerouslySetInnerHTML={{ __html: place.field_distributor_location }}></div>
                                                    <div className="distributor-map-marker-box-read-more" onClick={() => readMore()}>{`${Drupal.t('Read more')}`}</div>
                                                </div>
                                            </div>
                                        ) : null}
                                    </div>
                                )
                            } else {
                                return (
                                    <div
                                        className={`distributor-map-marker default-distributor-marker`}
                                        lat={Number(place.field_map_latitude)}
                                        lng={Number(place.field_map_longitude)}
                                        onClick={() => handleActiveMarker(i, placeLat, placeLng)}
                                        key={i}
                                    >
                                        {activeMarker === i ? (
                                            <div>
                                                <div className="distributor-map-marker-box">
                                                    <div className="distributor-map-marker-box-close" onClick={() => setActiveMarker(null)}>X</div>
                                                    <div className="distributor-map-marker-box-title" dangerouslySetInnerHTML={{ __html: place.field_short_name }}></div>
                                                    <div className="distributor-map-marker-box-address" dangerouslySetInnerHTML={{ __html: place.field_distributor_location }}></div>
                                                    <div className="distributor-map-marker-box-read-more" onClick={() => readMore()}>{`${Drupal.t('Read more')}`}</div>
                                                </div>
                                            </div>
                                        ) : null}
                                    </div>
                                )
                            }
                        })}
                        <div
                            className="distributor-map-marker-user"
                            lat={coordinates.lat}
                            lng={coordinates.lng}
                        ></div>
                    </GoogleMapReact>
                </div>
            </div> : <div className="bauer-distributor-map-container">
                <div className="bauer-distributor-finder-info-box-top" dangerouslySetInnerHTML={{ __html: ckEditorPre }}></div>
                {/*
            <div className="bauer-distributor-finder-info-box-top">
                <p>{`${Drupal.t('For US Industrial Air Applications, please contact us at')}`} <a href="mailto:IndustrialSales@bauercomp.com">IndustrialSales@bauercomp.com</a></p>
                <p>{`${Drupal.t('For Canada Industrial Air Applications, please contact Jeremy Rowand at')}`} <a href="mailto:jrowand@jordair.ca">jrowand@jordair.ca</a></p>
            </div>
            <div className="bauer-distributor-finder-info-box-middle">
                <p>{`${Drupal.t('Enter your City/State or Zip Code to find a breathing air distributor near you. (Fire Departments & Dive Shops).')}`}</p>
            </div>
            */}
                <div className="bauer-distributor-finder-info-box-bottom">
                    <div className="bauer-distributor-finder-info-image"></div>
                </div>
            </div>
        }
        </>
    );
}

export default Map;
